// src/pages/BookingSuccess.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BookingSuccessMessage from "../components/BookingSuccessMessage";

const BookingSuccess = () => {
  // Read the confirmed booking from localStorage
  const booking = JSON.parse(localStorage.getItem("currentBookingId")) || {};
  console.log("BookingSuccess - booking:", booking);
  return (
    <>
      <Header />
      <BookingSuccessMessage booking={booking} />
      <Footer />
    </>
  );
};

export default BookingSuccess;
